// Top-of-page decorative layer. Composes the KV-top gradient, four
// treetop silhouettes, three cherry-blossom deco PNGs, and a soft
// yellow light glow. Assets live in src/assets/kv/ and are added once
// the designer delivers them. Until then, this renders just the

import { Fit, Layout, Rive } from '@rive-app/canvas-lite'
import { onCleanup, onMount } from 'solid-js'
import rivKVTop from '~/assets/anim/kv-top.riv?url'

// gradient so the rest of the layout can be developed.
export function KvTop() {
  let canvas!: HTMLCanvasElement // oxlint-disable-line eslint/no-unassigned-vars
  let rive: Rive

  onMount(() => {
    rive = new Rive({
      src: rivKVTop,
      artboard: 'kv_top',
      canvas,
      autoplay: true,
      stateMachines: 'State Machine 1',
      layout: new Layout({ fit: Fit.FitHeight }),
      onLoad() {
        rive.resizeDrawingSurfaceToCanvas()
      },
    })
  })
  onCleanup(() => {
    rive?.cleanup()
  })

  return (
    <div
      aria-hidden
      class="pointer-events-none absolute left-0 right-0 top-0 h-[350px]"
    >
      <canvas ref={canvas} class="size-full" />
    </div>
  )
}
